export default __webpack_public_path__ + "static/media/GR00054-owl_50_mentor.714c4ad1.svg";